import "./App.scss";

import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter } from "react-router-dom";

import { ThemeProvider } from "@emotion/react";
import { createTheme } from "@mui/material";
import { themeMJB } from "./styles/theme/themeMaterialUI";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "./redux/configureStore";
import { LayoutContextProvider } from "./utils/LayoutContext/LayoutContext";
import { InfoModalProvider } from "./common/components/organisme/InfoModalV2/context/infoModalV2Context";
import mainPageRoutes from "./navigation/mainPageRoutes";
import RoutesGenerator from "./utils/navigation/RoutesGenerator/RoutesGenerator";





/**
 * 
 * @returns Component
 */
function App() {
  const routesList = mainPageRoutes;
  const defaultTheme = createTheme(themeMJB);
  const queryClient = new QueryClient({
    defaultOptions: { queries: { staleTime: 1000 * 60 * 5 } },
  });






  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <ThemeProvider theme={defaultTheme}>
          <InfoModalProvider>
            <BrowserRouter>
              <LayoutContextProvider>
                <QueryClientProvider client={queryClient}>
                  <RoutesGenerator routesList={routesList} />
                </QueryClientProvider>
              </LayoutContextProvider>
            </BrowserRouter>
          </InfoModalProvider>
        </ThemeProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
